'use client';

import HomeVoicesOfTrustShowcase from '@/components/sections/Home/HomeVoicesOfTrustShowcase';
import type { VideoTestimonialZone } from '@/types/homepage';
import type { TestimonialComponent } from '@/types/product';

interface ProductVoicesOfTrustShowcaseProps {
  testimonialComponent?: VideoTestimonialZone | TestimonialComponent;
  backgroundClassName?: string;
}

/**
 * Dark-theme Voices of Trust for the products landing page.
 * Shares the same showcase component as Home (`theme="dark"`).
 */
export default function ProductVoicesOfTrustShowcase({
  testimonialComponent,
  backgroundClassName,
}: ProductVoicesOfTrustShowcaseProps) {
  return (
    <HomeVoicesOfTrustShowcase
      testimonialComponent={testimonialComponent}
      theme="dark"
      styles={backgroundClassName ? { sectionClassName: backgroundClassName } : undefined}
    />
  );
}
